{
  "id": "campaign-110",
  "name": "Formal Gardens",
  "seed": "campaign:110",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....CCCCCC.....",
    ".....UCCCCU.....",
    ".......CC....x..",
    ".......CCx......",
    "....t..CC..t....",
    "......tCCt......",
    "..Y...CCCC...Y..",
    "......CwwC......",
    "....t.CwwC.t....",
    "......CwwC......",
    "..t..tCCCCt..t..",
    ".x,...*CC*..x...",
    ".,,,t.*CC*.t....",
    "..,...*CC*.,,,..",
    ".t....TCCT,,,.t.",
    "...........,....",
    "S.........x....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 14,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 3
    }
  ],
  "hills": [
    {
      "x": 3,
      "y": 10,
      "w": 3,
      "h": 3
    },
    {
      "x": 10,
      "y": 10,
      "w": 3,
      "h": 3
    }
  ],
  "generatorVersion": 3,
  "level": 110,
  "biome": "estate",
  "par": {
    "reel": 7304,
    "push": 6590,
    "selfPropelled": 6083,
    "tractor": 4934,
    "zeroTurn": 4268,
    "fairway": 2755
  },
  "goldTime": {
    "reel": 7304,
    "push": 6388,
    "selfPropelled": 5976,
    "tractor": 4934,
    "zeroTurn": 4268,
    "fairway": 2488
  },
  "routeTries": {
    "par": {
      "reel": 15,
      "push": 11,
      "selfPropelled": 0,
      "tractor": 23,
      "zeroTurn": 23,
      "fairway": 20
    },
    "gold": {
      "reel": 15,
      "push": 48,
      "selfPropelled": 25,
      "tractor": 23,
      "zeroTurn": 23,
      "fairway": 47
    }
  }
}
